import { axiosApi } from './helper'

export function getHigherOrderContacts() {
  return axiosApi('contacts/higher-order')
}